import {AssetResource} from './asset-resource';

export class LifeProject {
  name: string;
  description: string;
  type: number;
  enable: boolean;
  value: number;
  approved: boolean;
  computeCover: boolean;
  yearToGoal: number;
  yearCost: number;
  totalCost: number;
  savedMoney: number;
  otherMoney: number;
  note: string;
  tax: number;
  assets: AssetResource[] = [];
}
